var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticStyle: { display: "inline-block" } },
    [
      _c(
        "el-dropdown",
        { attrs: { "split-button": "", type: "danger", trigger: "click" } },
        [
          _vm._v(" 日志记录 "),
          _c(
            "el-dropdown-menu",
            {
              staticClass: "cargo-dropdown-menu",
              style: {
                width: _vm.menuWidth + "px",
                height: _vm.menuHeight + "px"
              },
              attrs: { slot: "dropdown" },
              slot: "dropdown"
            },
            [
              _c("sub-menu", {
                attrs: {
                  "menu-data": _vm.menuData,
                  "menu-context": _vm.menuContext,
                  "left-offset": _vm.menuItemWidth,
                  "item-height": _vm.menuItemHeight
                }
              })
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }